/**
 * @description
 * checks if an object or an array exists i.e !(null||undefined) and is not empty
 */
export const isNotEmptyObjOrArray = (objOrArray: unknown) => {
  /* null + undefined check */
  if (!objOrArray) return false;
  const isArray = Array.isArray(objOrArray);
  /* non-empty array check */
  if (isArray) return objOrArray.length > 0;
  /* non-empty object check */
  return Object.keys(objOrArray).length > 0;
};
